<template>
  <div class="lock-events-skeleton">
    <StSkeletonLoader
      v-for="i in 5"
      :key="i"
      height="76px"
      width="206px"
      bg-color="#2d2d39"
      :shimmer-opacity="0.28"
    />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.lock-events-skeleton {
  display: flex;
  gap: var(--spacing-100);
}
</style>
